<template>
  <div class="flex gap-2 h-full p-2 overflow-hidden">
    <div class="flex flex-col w-[250px] rounded overflow-hidden flex-shrink-0  gap-2">

      <div class="h-1/2 flex flex-col bg-trader-gray rounded overflow-hidden shrink-0">
        <h1 class=" text-lg text-white text-center bg-trader-darkest-gray dark:bg-trader-darker-gray py-1">Importieren</h1>

        <div class="flex-grow p-2 flex flex-col gap-2 overflow-auto">
          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'standard-import', 'bg-trader-dark-gray': activeView != 'standard-import' }"
               @click="showView('standard-import')">
            Standard Import
          </div>

          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'newsletter-import', 'bg-trader-dark-gray': activeView != 'newsletter-import' }"
               @click="showView('newsletter-import')">
            Newsletter Import
          </div>
        </div>
      </div>

      <div class="flex flex-col h-1/2 bg-trader-gray rounded overflow-hidden shrink-0">
        <h1 class=" text-lg text-center text-white bg-trader-darkest-gray dark:bg-trader-darker-gray py-1">Exportieren</h1>

        <div class="flex-grow p-2 flex flex-col gap-2 overflow-auto">
          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'standard-export', 'bg-trader-dark-gray': activeView != 'standard-export' }"
               @click="showView('standard-export')">
            Standard Export
          </div>
          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'standard-export-info', 'bg-trader-dark-gray': activeView != 'standard-export-info'  }"
               @click="showView('export-info')">
             Export Regional Info
          </div>
          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'primary-product-export', 'bg-trader-dark-gray': activeView != 'standard-export-info'  }"
               @click="showView('product')">
            Abbildungsartikel Export
          </div>
          <div class="w-full p-1 flex cursor-pointer" v-if="userData?.isSuperAdmin"
               :class="{ 'bg-trader-blue text-white': activeView == 'JSON', 'bg-trader-dark-gray': activeView != 'primary-product-export'  }"
               @click="showView('JSON')">
            JSON Export
          </div>
          <div class="w-full p-1 flex cursor-pointer"
               :class="{ 'bg-trader-blue text-white': activeView == 'JSON', 'bg-trader-dark-gray': activeView != 'primary-product-export'  }"
               @click="showView('Mailing')">
            Mailing (Top 5 Kunden Produkte)
          </div>
        </div>

      </div>
    </div>

    <div class="flex flex-grow rounded bg-trader-gray overflow-x-hidden overflow-y-auto">
      <div v-if="activeView == ''" class="flex flex-col p-4  w-full ">
        <h2 class="text-2xl font-bold">Willkommen beim Trader Import & Export</h2>
        <p class="text-md">Hier können Sie Daten einfach und effizient importieren oder exportieren. </p>
        <p class="text-md">Nutzen Sie das Menü auf der linken Seite, um eine Import- oder Exportvariante auszuwählen.</p>
        <p class="text-md">Nach Ihrer Auswahl führt Sie ein intuitiver Wizard durch die nächsten Schritte.</p>
      </div>

      <ImportExcel v-if="activeView == 'standard-import'" class="overflow-x-hidden overflow-y-auto"></ImportExcel>
      <ExportExcel v-if="activeView == 'standard-export'" class="overflow-x-hidden overflow-y-auto"></ExportExcel>
      <NewsletterImport v-if="activeView == 'newsletter-import'" :project-id="projectId" :magazine-id="magazineId" class="overflow-x-hidden overflow-y-auto"></NewsletterImport>
      <ExcelExportInfo v-if="activeView == 'export-info'" :project-id="projectId" :magazine-id="magazineId" class="overflow-x-hidden overflow-y-auto"></ExcelExportInfo>
      <PrimaryProductExport v-if="activeView == 'product'" class="overflow-x-hidden overflow-y-auto"></PrimaryProductExport>
      <JSONExport v-if="activeView == 'JSON' && userData?.isSuperAdmin"  class="overflow-x-hidden overflow-y-auto"></JSONExport>
      <CustomerExport v-if="activeView == 'Mailing' "></CustomerExport>
    </div>
  </div>
</template>

<script setup lang="ts">


import {eventBus} from "@/application/EventBus";
import NewsletterImport from "@/components/Dialogs/NewsletterImport.vue";
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import ImportExcel from "@/components/Dialogs/ImportExcel.vue";
import ExportExcel from "@/components/Dialogs/ExportExcel.vue";
import ExcelExportInfo from "@/components/Dialogs/ExcelExportInfo.vue";
import PrimaryProductExport from "@/components/Dialogs/PrimaryProductExport.vue";
import {mapState, useStore} from "vuex";
import JSONExport from "@/components/Dialogs/JSONExport.vue";
import CustomerExport from "@/components/Dialogs/CustomerExport.vue";
const store = useStore();
const userData = computed(() => store.state.user.userData);
const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const activeView = ref<string>("");

const route = useRoute(); // <-- Hier definierst du die Konstante 'route'

function showView(type: string) {
  activeView.value = type;
}

function goToNewsLetterImport() {
  eventBus.openModal(NewsletterImport, {
    title: "Newsletter Import",
    projectId: projectId.value,
    magazineId: magazineId.value
  });
}

function goToRegionalImport() {
  eventBus.openModal(ImportExcel, {
    title: "Regional Import",
    magazineId: magazineId.value
  });
}

onMounted(async () => {
  if (route.params.projectId) {
    projectId.value = parseInt(route.params.projectId as string, 10);
  }

  if (route.params.magazineId) {
    magazineId.value = parseInt(route.params.magazineId as string, 10);
  }
});


</script>